import React from 'react';

const StarbeatNoticeJP = () => {
  return (
    <>
      <ul className='starbeat-notice-desc-group'>
        <li className='starbeat-notice-desc-list'>
          <p className='starbeat-notice-desc-title'>Star Beat 利用案内</p>
          <ul className='starbeat-notice-desc-depth2-group'>
            <li className='starbeat-notice-desc-depth2-list'>
              - 有料で購入できるBeatとして、Mubeat Liveの商品購入およびMubeatアプリ内の
              広告募金・Playground等で使用いただけます。
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 購入されたStar BeatはWEB・アプリ内でもご利用いただけます。
            </li>
            <li className='starbeat-notice-desc-depth2-list'>- 有効期限：取得日から5年間。</li>
          </ul>
        </li>
        <li className='starbeat-notice-desc-list'>
          <p className='starbeat-notice-desc-title'>購入時の注意事項</p>
          <ul className='starbeat-notice-desc-depth2-group'>
            <li className='starbeat-notice-desc-depth2-list'>- Star Beatの金額には付加価値税が含まれています。</li>
            <li className='starbeat-notice-desc-depth2-list'>- Star Beat購入時、税金は国別で付加されます。</li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 未成年者が法定代理人の同意なく決済した場合、本人または法定代理人は決済をキャンセルすることができます。
              ただし、未成年者が本人を成人だと偽ったり、法定代理人の同意があると偽った場合にはキャンセルできかねます。
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 同一理由または同一タイプのStar Beatの撤回/払い戻しを繰り返し要請したり、
              不適当な理由で撤回/払い戻しを持続した場合、サービス利用に制約が生じる場合がございます。
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - Star Beatを購入してから7日(申し込み撤回期間)以内でのみ、払い戻しの申請が可能です。
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 有料決済後、未使用のStar Beatは購入日基準7日以内に払い戻しの申請が可能です。
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - Mubeatアプリ &gt; 設定 &gt;
              メールでお問い合わせ、またはsupport@mubeat.tvにメールで直接払い戻しの申請が可能です。
              下記フォームに従ってお問い合わせください。
              <br />
              タイトル：[WEB購入Star Beat 払い戻しについての問い合わせ]
              <br />
              内容:
              <ul className='starbeat-notice-desc-depth3-group'>
                <li className='starbeat-notice-desc-depth3-list'>
                  1) Star Beatを購入したMubeatアカウントのメールアドレス
                </li>
                <li className='starbeat-notice-desc-depth3-list'>
                  2) Mubeatアカウントのログインタイプ(マイページ &gt; ログインされているアカウントで確認できます。)
                </li>
                <li className='starbeat-notice-desc-depth3-list'>3) 購入したStar Beatの商品名と決済金額</li>
                <li className='starbeat-notice-desc-depth3-list'>4) 概要商品の決済日時</li>
                <li className='starbeat-notice-desc-depth3-list'>5) 払い戻しの理由</li>
              </ul>
            </li>
            <li className='starbeat-notice-desc-depth2-list'>
              - 正常に払い戻し処理が行われるまで、多少のお時間がかかる点ご了承ください。
              ただし、下記の場合は決済キャンセル処理できかねます。
              <ul className='starbeat-notice-desc-depth3-group'>
                <li className='starbeat-notice-desc-depth3-list'>
                  &#9312; イベント・クーポン・報酬等の決済手段が無料で支給された場合
                </li>
                <li className='starbeat-notice-desc-depth3-list'>&#9313; 該当期間内に使用履歴がある場合</li>
                <li className='starbeat-notice-desc-depth3-list'>
                  &#9314; 該当決済手段での決済キャンセル可能期間が経過している場合
                </li>
                <li className='starbeat-notice-desc-depth3-list'>&#9315; 会員様の過失がある場合</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

export default StarbeatNoticeJP;
